<template>
    <div
        class="chat-interaction-list"
    >
        <chat-assistent-interaction-skeleton
            :messages-count="1"
        />
        <chat-user-interaction-skeleton />
        <chat-function-interaction-skeleton />
        <chat-assistent-interaction-skeleton
            :messages-count="Math.floor(Math.random() * (maxAssistentMessages - minAssistentMessages + 1)) + minAssistentMessages"
        />
        <chat-user-interaction-skeleton />
    </div>
</template>

<script setup lang="ts">
    import ChatAssistentInteractionSkeleton from '@/ai/assistent/components/interaction/ChatAssistentInteractionSkeleton.vue';
    import ChatUserInteractionSkeleton from '@/ai/assistent/components/interaction/ChatUserInteractionSkeleton.vue';
    import ChatFunctionInteractionSkeleton from '@/ai/assistent/components/interaction/ChatFunctionInteractionSkeleton.vue';

    const minAssistentMessages = 1;
    const maxAssistentMessages = 4;
</script>

<style scoped lang="scss">
    .chat-interaction-list {
        display: flex;
        flex-direction: column;
        height: calc(100% - 80px);
        overflow-y: scroll;
        padding: size(md);
        gap: size(md);
        box-sizing: border-box;
    }
</style>
